import React, { useEffect, useState } from 'react';
import API from '@/lib/api';

const FreelanceFinderApi = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await API.post('/freelance-bidding/api/fetch',{
          platform : "Upwork",
          query : "React Native"
        });
        
        console.log('API Response Data:', response.data);
        setData(response.data);
      } catch (error) {
        console.error('API Fetch Error:', error.response?.data || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="p-6 text-white">
      <h1 className="text-2xl font-bold mb-4">Freelance Data Test</h1>
      {loading ? (
        <p>Loading API data...</p>
      ) : (
        <pre className="bg-slate-900 p-4 rounded border border-slate-800 text-xs overflow-x-auto text-green-400">
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  );
};

export default FreelanceFinderApi;